import React, { useEffect } from 'react';
import { bool, func, object } from 'prop-types';

import { useFormErrors } from '../../hooks/useFormErrors';
import { CheckboxButton, CheckboxButtonGroup, FormLabel, InputNumber, Modal, FormError } from '../../common';
import { useForm } from '@laramie/ui';
import { TIPS } from '../../../consts/tips';

const PlanPagoDefinicionCaducidadCuotaModal = (props) => {

    //hooks
    const [formValues, formHandle, , formSet] = useForm(props.data.entity);

    useEffect(() => formSet(props.data.entity), [props.data.entity]);

    const habilitaConsecutivas = formValues.caducidadCantidadCuotasNoConsecutivas > 1;
    const cuotasConsecutivas = (props.disabled || habilitaConsecutivas) ? formValues.caducidadCantidadCuotasConsecutivas : 0;

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        props.onConfirm({ ...formValues, caducidadCantidadCuotasConsecutivas: cuotasConsecutivas });
    };

    function getErrors() {
        const errors = {};

        if (!(formValues.cuotaDesde > 0)) errors.cuotaDesde = 'Ingresá un número mayor a cero';
        if (!(formValues.cuotaHasta > 0)) errors.cuotaHasta = 'Ingresá un número mayor a cero';

        return errors;
    }

    function getFormatErrors() {
        const errors = {};
        if (props.disabled) return errors;

        if (cuotasConsecutivas === 1) errors.caducidadCantidadCuotasConsecutivas = 'Ingresá 0 o un número mayor a 1';
        if (cuotasConsecutivas > formValues.caducidadCantidadCuotasNoConsecutivas) errors.caducidadCantidadCuotasConsecutivas = 'No puede superar las cuotas impagas';

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title="Caducidad"
                tipName={TIPS.NAME.MODALS.CADUCIDAD_DEFINICION_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="col-12 col-md-4">
                                    <FormLabel htmlFor="cuotaDesde" required>Cuota desde</FormLabel>
                                    <InputNumber
                                        name="cuotaDesde"
                                        placeholder=""
                                        className={`form-control ${errorOf('cuotaDesde') ? 'is-invalid' : ''}`}
                                        value={formValues.cuotaDesde}
                                        onChange={formHandle}
                                        precision={0}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('cuotaDesde')} />
                                </div>
                                <div className="col-12 col-md-4">
                                    <FormLabel htmlFor="cuotaHasta" required>Cuota hasta</FormLabel>
                                    <InputNumber
                                        name="cuotaHasta"
                                        placeholder=""
                                        className={`form-control ${errorOf('cuotaHasta') ? 'is-invalid' : ''}`}
                                        value={formValues.cuotaHasta}
                                        onChange={formHandle}
                                        precision={0}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('cuotaHasta')} />
                                </div>
                                <div className="col-12 col-md-4">
                                    <CheckboxButtonGroup label="Anticipo">
                                        <CheckboxButton
                                            name="caducidadAnticipoImpago"
                                            label="Anticipo impago"
                                            checked={formValues.caducidadAnticipoImpago}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </CheckboxButtonGroup>
                                </div>

                                <div className="col-12 col-md-4 m-top-10">
                                    <FormLabel htmlFor="caducidadCantidadCuotasNoConsecutivas">Cant. de cuotas impagas</FormLabel>
                                    <InputNumber
                                        name="caducidadCantidadCuotasNoConsecutivas"
                                        placeholder=""
                                        className={`form-control ${errorOf('caducidadCantidadCuotasNoConsecutivas') ? 'is-invalid' : ''}`}
                                        value={formValues.caducidadCantidadCuotasNoConsecutivas}
                                        onChange={formHandle}
                                        precision={0}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('caducidadCantidadCuotasNoConsecutivas')} />
                                </div>
                                <div className="col-12 col-md-4 m-top-10">
                                    <FormLabel htmlFor="caducidadCantidadCuotasConsecutivas">Cant. de cuotas consecutivas</FormLabel>
                                    <InputNumber
                                        name="caducidadCantidadCuotasConsecutivas"
                                        placeholder=""
                                        className={`form-control ${errorOf('caducidadCantidadCuotasConsecutivas') ? 'is-invalid' : ''}`}
                                        value={cuotasConsecutivas}
                                        onChange={formHandle}
                                        precision={0}
                                        disabled={props.disabled || !habilitaConsecutivas}
                                    />
                                    <FormError message={errorOf('caducidadCantidadCuotasConsecutivas')} />
                                </div>
                                <div className="col-12 col-md-4 m-top-10">
                                    <label htmlFor="caducidadCantidadDiasVencimiento" className="form-label">Cant. de días de vencimiento</label>
                                    <InputNumber
                                        name="caducidadCantidadDiasVencimiento"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.caducidadCantidadDiasVencimiento}
                                        onChange={formHandle}
                                        precision={0}
                                        disabled={props.disabled}
                                    />
                                </div>
                                {/* <div className="col-12 col-md-4 m-top-10">
                                    <label htmlFor="caducidadCantidadDeclaracionesJuradas" className="form-label">Cant. de DDJJ no presentadas</label>
                                    <InputNumber
                                        name="caducidadCantidadDeclaracionesJuradas"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.caducidadCantidadDeclaracionesJuradas}
                                        onChange={formHandle}
                                        precision={0}
                                        disabled={props.disabled}
                                    />
                                </div>*/}
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={() => props.onDismiss()}>Cancelar</button>
                                <button className="btn btn-primary" data-dismiss="modal" onClick={() => handleClickAceptar()}>Aceptar</button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal" onClick={() => props.onDismiss()}>Volver</button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

PlanPagoDefinicionCaducidadCuotaModal.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

PlanPagoDefinicionCaducidadCuotaModal.defaultProps = {
    disabled: false
};

export default PlanPagoDefinicionCaducidadCuotaModal;
